<template>
    <div class="Achievement-container">
        
        <div class="tabs">
            <a class="item" v-for="(item,index) in tabs" :key="index" :class="{active: index == activeName}" @click="tabChange(index)">{{item}}</a>
        </div>
        
        <div class="header" >
            <p>实验记录明细</p>
            <!-- <el-button round type="primary" @click="exportData" v-preventReClick>导出</el-button> -->
        </div>
        
        <div class="score-table" v-if="activeName == 'first'">
            <fictitiouslist></fictitiouslist>
        </div>
        <div class="score-table" v-if="activeName == 'second'">
            <competitionList></competitionList>
        </div>
        <div class="score-table" v-if="activeName == 'three'">
            <teachinglist @handleSelect="handleSelect"></teachinglist>
        </div>
    </div>
</template>

<script>
import fictitiouslist from './FictitiousList.vue';
import teachinglist from './TeachingList.vue';
import competitionList from './competitionList.vue';
import { constants } from 'zlib';
export default {
    data() {
        return {
            activeName: 'first',
            userId: this.$store.state.userId,
            tabs: {
                first: '练习模式',
                // second: '竞赛模式',
                three: '考核模式'
            },
            multipleSelection: []
        };
    },
    components: {
        fictitiouslist,
        teachinglist,
        competitionList
    },
    created() {
        // this.$refs.message.href = `http://liuwanr.cn:8080/attendance/exportPractice?studentId=${this.studentId}&courseId=${this.$store.state.courseId}&titles=%E5%BA%8F%E5%8F%B7,%E9%A1%B9%E7%9B%AE%E5%90%8D%E7%A7%B0,%E5%AE%9E%E9%AA%8C%E9%A1%B9%E7%9B%AE,%E8%80%83%E5%8B%A4%E8%AE%B0%E5%BD%95,%E7%AD%BE%E5%88%B0%E6%97%B6%E9%97%B4`;
    },
    methods: {
       
        exportData() {
            if(this.activeName == 'first'){
                location.href = `${this.api.exportProjectRecord}?userId=${this.userId}`
            }else if(this.activeName == 'second'){
                location.href = `${this.api.exportExperimentProjectRecord}?userId=${this.userId}`
            }else{
                if(this.multipleSelection.length != 0){
                    let arr = this.multipleSelection.map(e => e.reportId).join()
                    location.href = `${this.api.exportKdTeachReport}?reportIds=${arr}&userId=${this.userId}`
                }else{
                    this.$post(this.api.fictitiousRecord, { 
                        classId: this.$children[1].classId,
                        userId: this.userId,
                        page: 1,
                        size: this.$children[1].totals,
                        searchContent: this.core.encodeString(this.$children[1].searchContent),
                        source: 2,
                        systemId: 3
                    }).then(res => {
                        let arr = res.data.list.map(e => e.reportId).join()
                        location.href = `${this.api.exportKdTeachReport}?reportIds=${arr}&userId=${this.userId}`
                    }).catch(err => {});
                }
            }
        },
        tabChange(index){
            this.activeName = index
        },
        handleSelect(val){
            this.multipleSelection = val;
        }
    }
};
</script>

<style lang="scss" scopted>
.Achievement-container {
    width: 100%;
    padding: 20px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    box-shadow: 0px 0px 21px 0px rgba(48, 115, 248, 0.1);
    border-radius: 10px;
    text-align: center;
    overflow: hidden;
    .header {
        display: flex;
        justify-content: space-between;
        margin-top: 16px;
        p {
            margin-top: 14px;
            font-size: 20px;
            font-family: MicrosoftYaHeil;
            color: #333333;
        }
    }
    .score-table {
        margin-top: 18px;
        position: relative;
        .block {
            position: absolute;
            right: 0px;
            bottom: -50px;
        }
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #328aff;
        color: #fff;
    }
}
.tabs{
    display: flex;
    align-items: center;
    padding: 20px 0 0;
    margin: 0;
    // box-shadow:0px 0px 25px 2px rgba(48,115,248,0.14);
    z-index: 999;
    background-color: #fff;
    .item{
        padding: 12px 20px;
        margin-right: 10px;
        color:#606266;
        line-height: 1;
        border-radius: 4px;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        cursor: pointer;

        &.active{
            color: #fff;
            background-color: #328aff;
            border-color: #328aff;
        }
    }
}
</style>